export default __webpack_public_path__ + "images/FI.614c93c.png";